export enum TestIdsEnum {
  LoginForm = "LoginForm",
  LoginFormUsernameField = "LoginFormUsernameField",
  LoginFormPasswordField = "LoginFormPasswordField",
  LoginFormSubmitButton = "LoginFormSubmitButton",

  TopBarUsername = "TopBarUsername",
  TopBarUserMenu = "TopBarUserMenu",
  TopBarUserMenuOrganization = "TopBarUserMenuOrganization",

  TopBarUsersListLink = "TopBarUsersListLink",
  TopBarVenuesListLink = "TopBarVenuesListLink",

  UserListRow = "UserListRow",
  UserListRowViewUser = "UserListRowViewUser",

  VenueUpsertForm = "VenueUpsertForm",
  VenueListRow = "VenueListRow",
  VenueListRowEditButton = "VenueListRowEditButton",
  VenueUpsertFormSubmitButton = "VenueUpsertFormSubmitButton",
}

export const getTestSelector = (id: TestIdsEnum): string => {
  switch (id) {
    case TestIdsEnum.LoginFormUsernameField:
      return "#username";
    case TestIdsEnum.LoginFormPasswordField:
      return "#password";
    default:
      return `[data-test="${id}"]`;
  }
};
